<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Clientes
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Clientes</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]="formBuscaDatosGrillaPrincipal">
  <div class="card mb-2 wow">
    <div class="card-body">
      <div class="row filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" (click)="showModalAgregar()" size="sm" mdbWavesEffect>
          Agregar
        </button>
        <button type="button" mdbBtn color="info" (click)="showModalCargaMasiva()" size="sm" mdbWavesEffect
          *ngIf="canAddClientesMasivos">
          Carga masiva archivo
        </button>
      </div>

      <div class="filtros-body justify-content-between">
        <div class="row">
          <div class="col" style="max-width: 150px;">
            <div class="md-form">
              <input value="" type="text" id="rutCliente" class="form-control" placeholder="12345678-1" required
                #rutCliente formControlName="filtroPrincipalRutCliente" (blur)="mascaraRut($event)" />
              <label for="rutCliente">RUT Cliente</label>
            </div>
          </div>

          <div class="col" style="max-width: 200px;">
            <div class="md-form">
              <input value="" type="text" id="filtroPrincipalNombreCliente" class="form-control"
                placeholder="Nombre de cliente" required #nombre formControlName="filtroPrincipalNombreCliente" />
              <label for="nombre">Nombre</label>
            </div>
          </div>

          <div class="col" style="max-width: 200px;">
            <div class="md-form">
              <mdb-select label="Vendedor" [options]="optionsVendedor" [multiple]="true"
                placeholder="Seleccionar vendedor" [filterEnabled]="true"
                formControlName="filtroPrincipalVendedor"></mdb-select>
            </div>
          </div>

          <div class="col" style="max-width: 200px;">
            <div class="md-form">
              <mdb-select ngDefaultControl label="Comuna" id="comunafiltro" #comunafiltro
                [options]="optionsFiltroComuna" placeholder="Comuna" [filterEnabled]="true"
                formControlName="filtroPrincipalComuna"></mdb-select>
            </div>
          </div>

          <div class="col" style="max-width: 150px">

            <mdb-checkbox formControlName="filtroPrincipalxEstado"><span>Activo</span>
            </mdb-checkbox>

          </div>

          <div class="col" style="max-width: 150px">

            <mdb-checkbox formControlName="filtroPrincipalEstadoBloqueo"><span>Bloqueado</span></mdb-checkbox>

          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-muted filtros-footer justify-content-end" style="border-top: 1px solid #dee2e6">
      <!-- class="btn btn-info waves-light" -->
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="filtraExcelVistaPrincipal()">
        <mdb-icon fas icon="file-excel"></mdb-icon>
        Excel
      </button>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="filtraGrillaVistaPrincipal()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>


<section *ngIf="showButton" style="z-index: 2;">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 2;top: 25%;">
    <div class="example-flex-container" style="z-index: 2;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page"
          (click)="onScrollTop()">
          <mat-icon class="icon_ArrowUp">arrow_upward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<section style="z-index: 3;" *ngIf="showButtonDown">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 3;">
    <div class="example-flex-container" style="z-index: 3;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page"
          (click)="onScrollAbajo()">
          <mat-icon class="icon_ArrowUp">arrow_downward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Listado -->
<section infinite-scroll (scrolled)="onScrollDown($event)" style="z-index: 1;">
  <div class="card mb-2 wow" *ngIf="listOfCliente" style="z-index: 1;">
    <div class="card-body">

      <!-- SE COMENTA TABLE-RESPONSIVE -->
      <div class="">
        <table class="table table-striped table-hover table-sm align-middle TablePrincipal FontTablePrincipal"
          mdbTableEditor mdbTable mdbTableScroll scrollX="true" scrolly="true" maxHeight="500" striped="true"
          bordered="true" stickyHeaderBgColor="#E0E0E0" stickyHeaderTextColor="#212529" stickyHeader="true">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center" style="max-width: 10%;">Resumen</th>
              <th scope="col" class="text-center" style="min-width: 15%;max-width:15%;">RUT</th>
              <th scope="col" class="text-center" style="width: 30%;">Raz&oacute;n Social</th>
              <th scope="col" class="text-center" style="width: 30%;">Dirección</th>
              <th scope="col" class="text-center" style="width: 12%;">Est. Dir.</th>
              <th scope="col" class="text-center" style="width: 16%;">Comuna</th>
              <th scope="col" class="text-center" style="width: 16%;">Ciudad</th>
              <th scope="col" class="text-center" style="width: 12%;">Localidad</th>
              <th scope="col" class="text-center" style="width: 12%;">Est.</th>
              <th scope="col" class="text-center" style="width: 8%;">Bloq.</th>
              <th scope="col" class="text-center" style="width: 10%;">D. Per.</th>
              <th scope="col" class="text-center" style="width: 10%;">Dir.</th>
              <th scope="col" class="text-center" style="width: 10%;">D. Com.</th>
              <th scope="col" class="text-center" style="width: 10%;">D. Fin.</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngIf="loading">
              <td colspan="100%" style="text-align: center">
                <mdb-spinner spinnerColor="blue"></mdb-spinner>
              </td>
            </tr> -->
            <tr *ngIf="!loading && listOfCliente?.length === 0">
              <td colspan="100%" style="text-align: center">
                No se encontró información
              </td>
            </tr>
            <tr *ngFor="let cliente of listOfCliente; let i = index" (click)="ClickedRow(i,cliente)"
              [class.active]="i == HighlightRow" [ngClass]="{ 'ClientesSinDatos': hasMissingData(cliente) }">
              <td class="text-center" style="padding-left: 0%;">
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="showModalDetalleCliente(cliente)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
              </td>
              <td (click)="showModalDetalleCliente(cliente)" class="rut-col" style="padding-left:5px!important;">{{
                this.rutService.AgregarDV(cliente.rut) | rut }}</td>
              <td (click)="showModalDetalleCliente(cliente)">{{ cliente.razon_social }}</td>
              <td (click)="showModalDetalleCliente(cliente)">{{ cliente.direccion_completa }}</td>
              <td (click)="showModalDetalleCliente(cliente)" class="text-center">
                <div *ngIf="cliente.estado_direccion">
                  <mdb-badge pill="true" success="true">Activo</mdb-badge>
                </div>
                <div *ngIf="!cliente.estado_direccion">
                  <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
                </div>
              </td>
              <td (click)="showModalDetalleCliente(cliente)">{{ cliente.nombrecomuna }}</td>
              <td (click)="showModalDetalleCliente(cliente)">{{ cliente.nombreprovincia }}</td>
              <td (click)="showModalDetalleCliente(cliente)">{{ cliente.localidad }}</td>
              <td class="text-center">
                <div *ngIf="cliente.activo">
                  <mdb-badge pill="true" success="true">Activo</mdb-badge>
                </div>
                <div *ngIf="!cliente.activo">
                  <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
                </div>
              </td>
              <td class="text-center">
                <div class="text-center" *ngIf="!cliente.bloqueado">
                  <mdb-badge pill="true" success="true" danger="true" style="width: 15px; height: 15px; padding: 0">
                  </mdb-badge>
                </div>
                <div class="text-center" *ngIf="cliente.bloqueado">
                  <mdb-badge pill="false" danger="false" style="width: 15px; height: 15px; padding: 0"></mdb-badge>
                </div>
              </td>
              <td class="text-center">
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="showModalModificarDtoPersonales(cliente)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
              </td>
              <td class="text-center">
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="showModalModificarDtoDireccion(cliente)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
              </td>
              <td class="text-center">
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="showModalModificarDtoComerciales(cliente)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
              </td>
              <td class="text-center">
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="showModalModificarDtoFinancieros(cliente)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="100%" style="text-align: center">
                <div class="row pb-1 pt-1" id="spinnerX">
                  <div class="col-md-12 p-4">
                    <ngx-spinner bdColor="" bdoOpacity="0.9" size="default" color="#581f87" type="ball-pulse-sync"
                      [fullScreen]="false">
                    </ngx-spinner>

                  </div>
                </div>
              </td>

            </tr>
          </tbody>
          <!-- <Spinner -->

          <tfoot *ngIf="listOfCliente?.length > 0">
            <tr>
              <!-- Página {{ paginaActual }} de  {{ totalPaginas }} -->
              <th colspan="12">
                {{ PagPosActual }} de {{ totalPagPos }} ({{
                totalRegistrosPos
                }}
                registros)
                <!-- <div class="btn-toolbar" role="toolbar">
                  <div class="btn-group">
                    <div *ngIf="paginaActual != 1">
                      <button mdbBtn type="button" color="primary" mdbWavesEffect size="sm"
                        (click)="retrocedePaginaGrillaVistaPrincipal()">
                        <mdb-icon fas icon="angle-left" class="mr-1"></mdb-icon>Anterior
                      </button>
                    </div>
                    &nbsp;
                    <div *ngIf="paginaActual < totalPaginas">
                      <button mdbBtn type="button" color="primary" mdbWavesEffect size="sm"
                        (click)="avanzaPaginaGrillaVistaPrincipal()">
                        Siguiente
                        <mdb-icon fas icon="angle-right" class="ml-1"></mdb-icon>
                      </button>
                    </div>
                  </div>
                </div> -->
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

  </div>
</section>
<!-- <div class="row pb-5" style="text-align-last: center;">
  <div class="col-md-12 p-5" *ngIf="loading">
      <mdb-spinner spinnerColor="blue" bdOpacity=0.9 bdColor="" size="default" color="#581f87" type="ball-pulse-sync" [fullscreen]="false"></mdb-spinner>
  </div>
</div> -->

<!-- MODAL Agregar nuevo cliente (tabs con todas las opciones) -->
<div style="overflow-y: auto" mdbModal #datosAgregarPersonales="mdb-modal" class="modal fade" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="max-width: 90%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="datosAgregarPersonales.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body">
        <!-- Nav Tabs -->
        <mdb-tabset #staticTabs [buttonClass]="'md-tabs tabs-4 text-uppercase'" [contentClass]="'pd-0'">
          <!--Panel 1: Datos Personales-->
          <mdb-tab heading="Datos personales">
            <div class="row">
              <div class="col-12">
                <!-- (onRutExiste)="datosAgregarPersonales.hide()" -->
                <app-clientes-form-datos-personales mode="ADD" [optionsTipoCliente]="optionsTipoCliente"
                  [optionsCanal]="optionsCanal" (onNombreChange)="onNombreDatosPersonalesChange($event)" bandEdit="1"
                  (onOpenModalEdit)="onOpenEditProveedor($event)">
                </app-clientes-form-datos-personales>
              </div>
            </div>
          </mdb-tab>

          <!--Panel 2: Direcciones-->
          <mdb-tab heading="Direcciones">
            <div class="row">
              <div class="col-12">
                <form [formGroup]="formDatosDirecciones">
                  <div class="row" style="border-bottom: 1px solid #dee2e6">
                    <div class="col">
                      <h5 class="modal-title w-100 text-left" id="myModalLabel">
                        Datos de dirección
                      </h5>
                    </div>
                    <div class="col">
                      <div class="switch info-switch">
                        <label>
                          Inactivo
                          <input type="checkbox" formControlName="estadoDireccion" />
                          <span class="lever"></span> Activo
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="md-form" style="margin-bottom: 0">
                        ID interno <strong>{{ direccionCliente }}</strong>
                      </div>
                    </div>
                    <div class="col">
                      <div class="md-form" style="margin-bottom: 0">
                        <strong></strong>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="md-form" style="margin-bottom: 0">
                        <mdb-checkbox [checked]="true" formControlName="esCasaMatriz"><span style="font-size: 1rem">Casa
                            matriz</span></mdb-checkbox>
                      </div>
                      <div class="md-form">
                        <input value="" type="text" id="nombre3" class="form-control" placeholder="Nombre" required
                          formControlName="nombre" maxlength="100" #nombre3 />
                        <label for="nombre3">Nombre <app-required-field></app-required-field></label>
                        <div *ngIf="
                            formDatosDirecciones.get('nombre').invalid &&
                            (formDatosDirecciones.get('nombre').dirty ||
                              formDatosDirecciones.get('nombre').touched)
                          ">
                          <mdb-error *ngIf="
                              formDatosDirecciones.get('nombre').errors
                                .required
                            ">
                            Debe ingresar el nombre identificador de la
                            dirección
                          </mdb-error>
                          <mdb-error *ngIf="
                              formDatosDirecciones.get('nombre').errors
                                .minlength
                            ">
                            El nombre debe tener un mínimo de 5 caracteres
                          </mdb-error>
                        </div>
                      </div>

                      <div class="md-form">
                        <mdb-select label="Comuna" [options]="optionsDatosDireccionAgregarComuna" placeholder="Comuna"
                          [filterEnabled]="true" formControlName="comuna"></mdb-select>
                        <div *ngIf="
                                                  formDatosDirecciones.get('comuna').invalid &&
                                                  (formDatosDirecciones.get('comuna').dirty ||
                                                    formDatosDirecciones.get('comuna').touched)
                                                ">
                          <mdb-error *ngIf="
                                                    formDatosDirecciones.get('comuna').errors
                                                      .required
                                                  ">
                            La comuna es requerida
                          </mdb-error>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="md-form" [ngStyle]="{'display': ShowLongLat == false ? 'block' : 'none'}">
                            <input value="" type="text" id="direccionForm" name="direccionForm" class="form-control"
                              placeholder="Ingrese dirección o selecione de la lista" formControlName="direccion"
                              autocorrect="off" autocapitalize="off" autocomplete="off" spellcheck="off"
                              (keydown.enter)="$event.preventDefault()" #direccionForm />

                            <input type="hidden" formControlName="direccionFormateada">

                            <label for="direccion4">Dirección <app-required-field></app-required-field>
                            </label>

                          </div>

                          <div class="md-form" *ngIf="ShowLongLat === true">
                            <input value="" type="text" id="direccionForm" name="direccion" class="form-control"
                              placeholder="Ingrese dirección" formControlName="direccNueva">


                            <label for="direccion4">Dirección <app-required-field></app-required-field>
                            </label>
                          </div>

                        </div>
                      </div>


                      <div class="row">
                        <div class="col">
                          <mdb-checkbox [checked]="false" formControlName="showCoordenadas"
                            (change)="ShowCoordenadasLatLong($event)">
                            <span style="font-size: 1rem">Ingreso manual de coordenadas</span>
                          </mdb-checkbox>
                        </div>
                      </div>

                      <!-- <div class="md-form" >
                    <label for="search">Dirección </label>

                    <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()" placeholder="Buscar dirección en mapa"
                    autocorrect="off" autocapitalize="off"  autocomplete="off"
                      spellcheck="off" type="text" #search>
                  </div> -->
                      <div class="md-form">
                        <agm-map [fitBounds]="true" [usePanning]="true" [latitude]="latitude" [longitude]="longitude"
                          [zoom]="zoom" id="mapa">
                          <agm-marker [agmFitBounds]="true" [latitude]="latitude" [longitude]="longitude"
                            [markerDraggable]="true" (dragEnd)="markerDragEnd($event)" id="marcadores"></agm-marker>
                        </agm-map>
                      </div>

                      <div class="row">

                        <div class="col">
                          <div class="md-form">
                            <input value="" type="text" id="latitud" class="form-control" placeholder="Latitud" required
                              #latitud formControlName="latitud" [readonly]="ShowLongLat === false" />
                            <label for="latitud">Latitud</label>
                            <div *ngIf="
                                formDatosDirecciones.get('latitud')
                                  .invalid &&
                                (formDatosDirecciones.get('latitud')
                                  .dirty ||
                                  formDatosDirecciones.get('latitud')
                                    .touched)
                              ">
                              <mdb-error *ngIf="
                                  formDatosDirecciones.get('latitud')
                                    .errors.required
                                ">
                                La latitud es requerida
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="md-form">
                            <input value="" type="text" id="longitud" class="form-control" placeholder="Longitud"
                              required #longitud formControlName="longitud" [readonly]="ShowLongLat === false" />
                            <label for="longitud">Longitud</label>
                            <div *ngIf="
                                formDatosDirecciones.get('longitud')
                                  .invalid &&
                                (formDatosDirecciones.get('longitud')
                                  .dirty ||
                                  formDatosDirecciones.get('longitud')
                                    .touched)
                              ">
                              <mdb-error *ngIf="
                                  formDatosDirecciones.get('longitud')
                                    .errors.required
                                ">
                                La longitud es requerida
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="md-form">
                            <input value="" type="number" id="secuencia" class="form-control"
                              formControlName="secuencia" />
                            <label for="secuencia">Secuencia</label>
                          </div>
                        </div>
                        <!-- <div class="col">
                      <button mdbBtn type="button" color="info" mdbWavesEffect>
                        <mdb-icon fas icon="map-marker-alt"></mdb-icon> Ver en Google Maps
                      </button>
                       </div> -->
                      </div>
                      <!-- <h5>Address: {{address}}</h5>
                       <div>Latitude: {{latitude}}</div>
                    <div>Longitude: {{longitude}}</div> -->
                    </div>

                    <div class="col">
                      <div class="row mb-2" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Datos dirección
                          </h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="md-form" style="margin-bottom: 0">
                            <mdb-checkbox [checked]="true" formControlName="usaDireccionDespacho"
                              (change)="manejadorDireccionDespacho(false)">
                              <span style="font-size: 1rem">Despachar a misma dirección</span>
                            </mdb-checkbox>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-6">
                          <div class="md-form">
                            <mdb-select label="Dirección" placeholder="Dirección" [options]="optionsDireccion"
                              [filterEnabled]="true" formControlName="direccionDespacho"></mdb-select>
                            <div *ngIf="
                                                  formDatosDirecciones.get('direccionDespacho')
                                                    .invalid &&
                                                  (formDatosDirecciones.get('direccionDespacho')
                                                    .dirty ||
                                                    formDatosDirecciones.get(
                                                      'direccionDespacho'
                                                    ).touched)
                                                ">
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get(
                                                      'direccionDespacho'
                                                    ).errors.required
                                                  ">
                                La dirección de despacho es requerida
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="text" id="localidad" class="form-control" placeholder="Localidad"
                              #localidad formControlName="localidad" />
                            <label for="localidad">Localidad</label>
                            <div *ngIf="
                                                  formDatosDirecciones.get('localidad')
                                                    .invalid &&
                                                  (formDatosDirecciones.get('localidad')
                                                    .dirty ||
                                                    formDatosDirecciones.get('localidad')
                                                      .touched)
                                                "></div>
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="md-form">
                            <mdb-select label="Territorio" [options]="optionsTerritorioDireccion"
                              placeholder="Territorio" [filterEnabled]="true" formControlName="territorio"></mdb-select>
                            <div *ngIf="
                                                  formDatosDirecciones.get('territorio')
                                                    .invalid &&
                                                  (formDatosDirecciones.get('territorio')
                                                    .dirty ||
                                                    formDatosDirecciones.get('territorio')
                                                      .touched)
                                                ">
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get('territorio')
                                                      .errors.required
                                                  ">
                                El territorio es requerido
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <mdb-select label="Ruta" [options]="optionsRutaDireccion" placeholder="Ruta"
                              [filterEnabled]="true" formControlName="ruta"></mdb-select>
                            <div *ngIf="
                                                  formDatosDirecciones.get('ruta').invalid &&
                                                  (formDatosDirecciones.get('ruta').dirty ||
                                                    formDatosDirecciones.get('ruta').touched)
                                                ">
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get('ruta').errors
                                                      .required
                                                  ">
                                La ruta es requerida
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-2" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Datos de contacto
                          </h5>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="text" id="contacto" class="form-control" placeholder="Contacto"
                              #contacto formControlName="contacto" />
                            <label for="contacto">Contacto</label>
                            <!-- <div *ngIf="
                                                formDatosDirecciones.get('contacto').invalid &&
                                                  (formDatosDirecciones.get('contacto').dirty ||
                                                  formDatosDirecciones.get('contacto').touched)
                                                ">
                                                <mdb-error *ngIf="
                                                  formDatosDirecciones.get('contacto').errors
                                                      .required
                                                  ">
                                                  El contacto es requerido
                                                </mdb-error>
                                              </div> -->
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="text" id="fijo" class="form-control" placeholder="Fijo" #fijo
                              formControlName="fijo" />
                            <label for="fijo">Fijo</label>
                            <!-- <div *ngIf="
                                              formDatosDirecciones.get('fijo').invalid &&
                                                (formDatosDirecciones.get('fijo').dirty ||
                                                formDatosDirecciones.get('fijo').touched)
                                              ">
                                              <mdb-error *ngIf="
                                                formDatosDirecciones.get('fijo').errors
                                                    .required
                                                ">
                                                El teléfono fijo es requerido
                                              </mdb-error>
                                            </div> -->
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="text" id="movil" class="form-control" placeholder="Movil" #movil
                              formControlName="movil" />
                            <label for="movil">Movil</label>
                            <!-- <div *ngIf="
                                                formDatosDirecciones.get('movil').invalid &&
                                                  (formDatosDirecciones.get('movil').dirty ||
                                                  formDatosDirecciones.get('movil').touched)
                                                ">
                                                          <mdb-error *ngIf="
                                                  formDatosDirecciones.get('movil').errors
                                                      .required
                                                  ">
                                                  El móvil es requerido
                                                </mdb-error>
                                              </div> -->
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="md-form">
                            <input value="" type="email" id="email" class="form-control" placeholder="Email" #email
                              formControlName="email" />
                            <label for="email">Email</label>
                            <div *ngIf="
                                                  formDatosDirecciones.get('email').invalid &&
                                                  (formDatosDirecciones.get('email').dirty ||
                                                    formDatosDirecciones.get('email').touched)
                                                ">
                              <!-- <mdb-error *ngIf="
                                                  formDatosDirecciones.get('email').errors
                                                      .required
                                                  ">
                                                  El email es requerido
                                                </mdb-error> -->
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get('email').errors
                                                      .email
                                                  ">
                                El email es inválido
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row" *ngIf="HidenEmpresaHeredada === true">
                        <div class="col">
                          <mdb-checkbox [checked]="true" formControlName="showEmpresaHeredada"
                            (change)="checkEmpresa($event)" [disabled]="true">
                            Visibilidad Savory
                          </mdb-checkbox>
                        </div>
                      </div>
                      <div class="row" *ngIf="HidenEmpresaHeredada === true"
                        [ngStyle]="{'display': formDatosDirecciones.get('showEmpresaHeredada').value === true ? 'flex' : 'none'}">
                        <div class="col-auto" style="margin-top:1%;">
                          <label for="empresaHeredada" class="form-check-label">Empresa Destino</label>
                        </div>
                        <div class="col-3 mdb-form">
                          <mdb-select [options]="optionsEmpresaAlterna" id="empresaHeredada"
                            placeholder="Seleccionar empresa" [filterEnabled]="true" formControlName="EmpresaAlteSel"
                            [disabled]="true"></mdb-select>
                        </div>
                      </div>

                      <div class="row" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Referencias
                          </h5>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <!--Basic textarea-->
                          <div class="md-form">
                            <textarea type="text" id="form7" class="md-textarea form-control" placeholder="Escribe aquí"
                              mdbInput formControlName="referencias" maxlength="160"></textarea>
                            <div *ngIf="
                                                  formDatosDirecciones.get('referencias')
                                                    .invalid &&
                                                  (formDatosDirecciones.get('referencias')
                                                    .dirty ||
                                                    formDatosDirecciones.get('referencias')
                                                      .touched)
                                                ">
                              <mdb-error *ngIf="
                                                    formDatosDirecciones.get('referencias')
                                                      .errors.maxlength
                                                  ">
                                Las referencias no pueden contener más de 160
                                caracteres
                              </mdb-error>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Facturar a
                          </h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col dato" style="min-width: 350px; display: flex; align-items: center;">
                          <div class="form-check form-check-inline" style="margin-right: 20px">
                            <input type="radio" class="form-check-input" mdbInput id="casa_matriz"
                              [value]="RB_CASAMATRIZ_" formControlName="facturarACasaMatriz" />
                            <label class="form-check-label" for="casa_matriz">Casa matriz</label>
                          </div>

                          <!-- Material inline 2 -->
                          <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input" mdbInput id="esta_direccion"
                              [value]="RB_DIRECCION_ACT" formControlName="facturarACasaMatriz" />
                            <label class="form-check-label" for="esta_direccion">Esta dirección</label>
                          </div>
                        </div>
                      </div>

                      <div class="row" style="border-bottom: 1px solid #dee2e6">
                        <div class="col">
                          <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Agregar vendedor
                          </h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="md-form">
                            <mdb-select label="Vendedor" [options]="optionsVendedor" placeholder="Seleccionar vendedor"
                              [filterEnabled]="true" formControlName="VendedorSel"></mdb-select>
                          </div>
                        </div>
                        <!-- <div class="col">
                                            <div class="md-form">
                                              <mdb-select label="Rubro" [options]="optionsRubro" placeholder="Seleccionar Rubro"
                                                [filterEnabled]="true" formControlName="RubroSel"></mdb-select>
                                            </div>
                                          </div> -->
                        <div class="col">
                          <button mdbBtn type="button" color="info" mdbWavesEffect (click)="agregaVendedorRubro()">
                            Agregar
                          </button>
                        </div>
                      </div>


                    </div>
                  </div>



                  <div class="row" style="margin-top: 20px">
                    <div class="table-responsive">
                      <table class="
                          table table-striped table-hover table-sm
                          align-middle
                        ">
                        <thead class="grey lighten-2">
                          <tr>
                            <th colspan="3"></th>
                            <th colspan="7">IPT</th>
                            <th colspan="2"></th>
                          </tr>
                          <tr>
                            <th scope="col">Cod.</th>
                            <th scope="col">Vendedor</th>
                            <!-- <th scope="col">Rubro</th> -->
                            <th scope="col">L</th>
                            <th scope="col">M</th>
                            <th scope="col">Mi</th>
                            <th scope="col">J</th>
                            <th scope="col">V</th>
                            <th scope="col">S</th>
                            <th scope="col">D</th>
                            <th class="text-center">Cobranza</th>
                            <th scope="col">Rubros</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let rubroipt of listaClienteVendedorRubroIPTFixed; let i = index">
                            <tr>
                              <td>{{ rubroipt.vendedor_codigo }}</td>
                              <td>{{ rubroipt.nombreVendedor }}</td>
                              <!-- <td>{{ rubroipt.nombreRubro }}</td> -->
                              <td>
                                <mdb-checkbox *ngIf="rubroipt.lunes" class="checkbox-teal" [checked]="true"
                                  (click)="CambiaIPT('lunes', rubroipt, i)"></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.lunes" class="checkbox-teal"
                                  (click)="CambiaIPT('lunes', rubroipt, i)"></mdb-checkbox>
                              </td>
                              <td>
                                <mdb-checkbox *ngIf="rubroipt.martes" [checked]="true" class="checkbox-teal"
                                  (click)="CambiaIPT('martes', rubroipt, i)"></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.martes" class="checkbox-teal"
                                  (click)="CambiaIPT('martes', rubroipt, i)"></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.miercoles" [checked]="true" class="checkbox-teal" (click)="
                                  CambiaIPT('miercoles', rubroipt, i)
                                "></mdb-checkbox>

                                <mdb-checkbox *ngIf="!rubroipt.miercoles" class="checkbox-teal" (click)="
                                  CambiaIPT('miercoles', rubroipt, i)
                                "></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.jueves" [checked]="true" class="checkbox-teal"
                                  (click)="CambiaIPT('jueves', rubroipt, i)"></mdb-checkbox>
                                <mdb-checkbox class="checkbox-teal" *ngIf="!rubroipt.jueves"
                                  (click)="CambiaIPT('jueves', rubroipt, i)"></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.viernes" [checked]="true" class="checkbox-teal" (click)="
                                  CambiaIPT('viernes', rubroipt, i)
                                "></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.viernes" class="checkbox-teal" (click)="
                                  CambiaIPT('viernes', rubroipt, i)
                                "></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.sabado" [checked]="true" class="checkbox-teal"
                                  (click)="CambiaIPT('sabado', rubroipt, i)"></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.sabado" class="checkbox-teal"
                                  (click)="CambiaIPT('sabado', rubroipt, i)"></mdb-checkbox>
                              </td>

                              <td>
                                <mdb-checkbox *ngIf="rubroipt.domingo" [checked]="true" class="checkbox-teal" (click)="
                                  CambiaIPT('domingo', rubroipt, i)
                                "></mdb-checkbox>
                                <mdb-checkbox *ngIf="!rubroipt.domingo" class="checkbox-teal" (click)="
                                  CambiaIPT('domingo', rubroipt, i)
                                "></mdb-checkbox>
                              </td>

                              <td class="text-center">
                                <div class="form-check">
                                  <input type="radio" class="form-check-input" [id]="rubroipt.vendedor_codigo"
                                    [checked]="rubroipt.es_cobrador" (change)="handleChangeCobrador(rubroipt)"
                                    mdbInput />
                                  <label class="form-check-label" [for]="rubroipt.vendedor_codigo"></label>

                                  <!-- <input *ngIf="rubroipt.es_cobrador" type="radio" class="form-check-input"
                                  id="{{ rubroipt.rubro_codigo }}" name="groupOfRadioGap" [checked]="true" (click)="
                                    handleChangeAgregar2(
                                      rubroipt.es_cobrador,
                                      i
                                    )
                                  " mdbInput />
                                <input *ngIf="!rubroipt.es_cobrador" type="radio" class="form-check-input"
                                  id="{{ rubroipt.rubro_codigo }}" name="groupOfRadioGap" (click)="
                                    handleChangeAgregar2(
                                      rubroipt.es_cobrador,
                                      i
                                    )
                                  " mdbInput />
                                <label class="form-check-label" for="{{ rubroipt.rubro_codigo }}"></label> -->
                                </div>
                              </td>
                              <td>
                                <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect
                                  class="btn-actions-sm" (click)="verRubros(rubroipt, i)">
                                  <mdb-icon fas icon="eye"></mdb-icon>
                                </button>
                              </td>
                              <td>
                                <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect
                                  class="btn-actions-sm" (click)="eliminaVendedorRubro(rubroipt)">
                                  <mdb-icon fas icon="trash"></mdb-icon>
                                </button>
                              </td>
                            </tr>
                            <ng-container *ngIf="rubroipt.rubrosVisibles">
                              <tr>
                                <td colspan="100%" style="text-align: center">
                                  <div
                                    style="white-space: break-spaces; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                                    <ng-container *ngFor="let rubro of rubroipt.rubros">
                                      <div class="chip green lighten-2 white-text"
                                        style="position: unset; padding-right: 28px; cursor: default;">
                                        {{rubro.nombreRubro}}
                                        <!-- <mdb-icon fas icon="times" class="close"
                                          style="position: relative; right: -32px;"
                                          (click)="eliminaRubroAssigned(rubroipt, rubro)">
                                        </mdb-icon> -->
                                      </div>
                                    </ng-container>
                                  </div>
                                </td>
                              </tr>
                            </ng-container>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </mdb-tab>

          <!--Panel 3: Datos Comerciales-->
          <mdb-tab heading="Datos comerciales">
            <div class="row">
              <div class="col-12">
                <app-clientes-form-datos-comerciales>
                </app-clientes-form-datos-comerciales>
              </div>
            </div>
          </mdb-tab>

          <!--Panel 4: Datos Financieros-->
          <mdb-tab heading="Datos financieros">
            <div class="row">
              <div class="col-12">
                <app-clientes-form-datos-financieros [optionsTipoCobro]="optionsTipoCobro"
                  [optionsCondicionPago]="optionsCondicionPago" [optionsListaPrecios]="optionsListaPrecios">
                </app-clientes-form-datos-financieros>
              </div>
            </div>
          </mdb-tab>
        </mdb-tabset>
      </div>

      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="datosAgregarPersonales.hide()" mdbWavesEffect>
          Cerrar
        </button>

        <!-- (click)="validaExisteClienteProveedorParaAgregar()" -->
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          (click)="validarYAgregar()">
          <!-- [disabled]="(!((formAgregaDatosPersonales.valid) && (formDatosDirecciones.valid) && (formDatosComercialesyFacturadorEAgrega.valid)))" -->
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <app-carga-masiva-clientes></app-carga-masiva-clientes> -->
<app-modal-carga-masiva></app-modal-carga-masiva>

<!-- MODAL Editar Datos personales -->
<app-mantenedor-clientes-modal-datos-personales [optionsTipoCliente]="optionsTipoCliente" [optionsCanal]="optionsCanal"
  (onSuccess)="filtraGrillaVistaPrincipal()">
</app-mantenedor-clientes-modal-datos-personales>

<!-- MODAL Direcciones-->
<app-mantenedor-clientes-modal-direcciones [permiteUnidadNegocio]="permiteUnidadNegocio"
  (onSuccess)="UpdateTablaPrincipal()"
  [optionsUnidadesDeNegocio]="optionsUnidadesDeNegocio"></app-mantenedor-clientes-modal-direcciones>

<!-- MODAL Datos comerciales -->
<app-mantenedor-clientes-modal-datos-comerciales (onSuccess)="filtraGrillaVistaPrincipal()">
</app-mantenedor-clientes-modal-datos-comerciales>

<!-- MODAL Datos financieros -->
<app-mantenedor-clientes-modal-datos-financieros [optionsTipoCobro]="optionsTipoCobro"
  [optionsCondicionPago]="optionsCondicionPago" [optionsListaPrecios]="optionsListaPrecios"
  (onSuccess)="filtraGrillaVistaPrincipal()">
</app-mantenedor-clientes-modal-datos-financieros>

<!-- MODAL Detalle de cliente -->
<app-mantenedor-clientes-modal-resumen></app-mantenedor-clientes-modal-resumen>

<!-- MODAL Editar Proveedor -->
<app-modal-edit-proveedor (onSuccess)="filtraGrillaVistaPrincipal()"></app-modal-edit-proveedor>
